import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import {
  GetProvinces,
  GetCitys,
  GetAreas,
  GetAgentList,
  GetParmConfig, //寄送，支付接口
  GetProductClass,
  GetAgentConsigneeList,
  Consignee_Add,
  GetEmployList,
  ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "../chooseDialog/index.vue" //选择代理商、园所弹窗
import AddressDialog from "../AddressDialog/index.vue" // 选择收货地址弹窗
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue'; //添加幼儿园（原开课申请）
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式

// 公用弹窗:
// 1.会销开课（开课，新增开课isKaike，转园开课isSchoolKaike） 转会销开课
// 2.会销相关订单(查看、修改)
// 3.续订资源包 PackageId==10082
export default {
  mixins: [services],
  components: {
    chooseDialog,
    AddressDialog,
    optOpenClassDialog,
    payTypeInfo,
  },
  props: {
    value: {
      type: Boolean,
      default: null
    },
  },
  created() {
    this.getPay(8);
    this.getPay(9);

  },
  data() {
    return {
      num: 1,
      loading: false,
      agent: '',
      school: '',
      packagesD: this.getPackages(),
      packageZ: this.getPackageZ(),
      transportList: [], //寄送方式
      PayList: [], //支付方式
      form: this.getSubmitFormData(),
      SchoolConsigneeList: [],
      ConsigneeList: '', //收货地址
      ConsigneeListName: '', //联系人及电话
      AddDialogVisible: false,
      showData: this.getShowData(), //弹窗传参
      pageIndex: 1,
      pageSize: 10,
      minNum: 1,
      maxNum: Infinity,
      isOpen: false, //是否开班
      isDelShow: [false],
      payTypesArea: [],
      payList: [{}],
      addDialogVisiable: false, //新增代理商
      packagesOne: true, // true显示开课配置资源包样式
      GoodsListNum: [{
        "ProId": "",
        "ProNum": 30
      }],
      ListData: [],
      PayListData: [],
      PackageName: "",
      JianZ: true, //简装
      JingZ: true, //精装
      PayObject: [{
        Id: 0,
        label: "园所"
      }, {
        Id: 1,
        label: "代理商"
      }],
      ClassNum: 1,
      isKaike: false,
      debtPackage: this.getDebtInfoData(), //未提货资源包（即所欠资源包套数）
      isSchoolKaike: false,
      OldSchoolId: '',
      TotalPrice: 0,

    }
  },
  methods: {
    // 资源包
    getPackages() {
      return cloneDeep([{
        ProId: 341,
        value: 'Hi 英语-A',
        ProNum: 0
      }, {
        ProId: 342,
        value: 'Hi 英语-B',
        ProNum: 0
      }, {
        ProId: 343,
        value: 'Hi 英语-C',
        ProNum: 0
      }, {
        ProId: 344,
        value: 'Hi 英语-D',
        ProNum: 0
      }, {
        ProId: 345,
        value: 'Hi 英语-E',
        ProNum: 0
      }, {
        ProId: 346,
        value: 'Hi 英语-F',
        ProNum: 0
      }]);
    },
    getPackageZ() {
      return cloneDeep([{
        ProId: 382,
        value: '快乐儿童英语预备级 a',
        ProNum: 0
      }, {
        ProId: 383,
        value: '快乐儿童英语预备级 b',
        ProNum: 0
      }, {
        ProId: 384,
        value: '快乐儿童英语俱乐部 A',
        ProNum: 0
      }, {
        ProId: 385,
        value: '快乐儿童英语俱乐部 B',
        ProNum: 0
      }, {
        ProId: 386,
        value: '快乐儿童英语俱乐部 C',
        ProNum: 0
      }, {
        ProId: 387,
        value: '快乐儿童英语俱乐部 D',
        ProNum: 0
      }, {
        ProId: 388,
        value: '快乐儿童英语俱乐部 E',
        ProNum: 0
      }, {
        ProId: 389,
        value: '快乐儿童英语俱乐部 F',
        ProNum: 0
      }]);

    },
    getSubmitFormData() {
      return cloneDeep({
        "OrderId": 0,
        "AgentId": 0,
        "SchoolId": 0,
        "ClassNum": 1,
        "PackageId": "", //类型：开课1008，升级开课10081
        "SchoolConsigneeId": 0,
        "SendMode": 223,
        "PayMode": 222,
        "GoodsList": [],
        "VirtualList": [],
        "OrderPrice": 0,
        //支付方式
        "ListMeetPay": [],
        // 是否已经存在申请
        "ExistMeetOrder": 0,
        // 修改地址提交数据
        "ConsigneeProvId": 0,
        "ConsigneeCityId": 0,
        "ConsigneeAreaId": 0,
        "ConsigneeAddress": "",
        "Consignee": "",
        "ConsigneeTel": "",
        "SysId": "",
        "PayObject": null, //支付对象
        "OrderRemark": "",
        "OrderPostPrice": '', //邮费
      });
    },
    // 未提资源包集合
    getDebtInfoData() {
      return cloneDeep({
        HiDebtInfo: 0, //hi幼教未提资源包数
        BookHiData: 0, //智趣坞未提资源包数
        FreePostData: 0 //免邮次数
      });
    },
    // 类型选择（开课，升级开课）
    changeValue(val) {
      //this.showData.PackageId 不为空，即是查看或修改，否则为新增
      if (!this.showData.PackageId) {
        //开课
        console.log('kaike')
        if (val !== '' && this.form.SchoolId !== 0) {
          if (!this.isSchoolKaike) {
            this.getSchoolOpenInfo(this.form.SchoolId, val)
          } else {
            // 转园开课
            this.getSchoolOpenInfo(this.OldSchoolId, val)
          }

        }
        this.payList = [{}]

      } else {
        // 修改
        console.log('xiuhgai')
        if (val == this.showData.PackageId) {
          this.payList = this.PayListData
          this.GoodsListNum = this.ListData
        } else {
          this.payList = [{}]
        }
        // // 升级开课切换成开课
        // if (this.ListData.length > 0) {
        //     // 1008切换10081操作
        //     this.GoodsListNum = this.ListData
        // } else {
        //     // 10081切换1008操作
        //     this.GoodsListNum = []
        //     for (let i = 0; i < this.showData.ClassNum; i++) {
        //         this.GoodsListNum.push({
        //             ProId: "",
        //             ProNum: 30
        //         })
        //     }
        // }

      }
      // // 显示选择代理商按钮操作
      // if (val == 1008) {
      //     this.packagesOne = true
      // } else {
      //     this.packagesOne = false
      // }

    },
    // 开班数
    changeNum(val) {

      // if (this.form.PackageId == 1008) {
      //     if (val > this.form.ClassNum) {
      //         // 加
      //         let len = val - this.form.ClassNum

      //         for (let i = 0; i < len; i++) {
      //             this.GoodsListNum.push({
      //                 ProId: "",
      //                 ProNum: 30
      //             })
      //         }
      //     } else {
      //         // 减
      //         let len = this.form.ClassNum - val
      //         for (let i = 0; i < len; i++) {
      //             this.GoodsListNum.pop()
      //         }
      //     }

      // }

    },

    addFn() {
      this.payList.push({})
      this.isDelShow.push(true)
    },
    delPayFn(item) {
      this.payList.splice((item.index - 1), 1);

    },
    // 获取组件chooseDialog 值
    getDialogList(item) {
      // 切换代理商或园所重置资源包数据
      this.packagesD = this.getPackages();
      this.debtPackage = this.getDebtInfoData()
      this.form.PayObject = null;
      if (item.title == '选择代理商') {
        this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
        this.form.AgentId = item.Id,
          this.school = '',
          this.form.SchoolId = 0,
          this.ConsigneeList = '',
          this.ConsigneeListName = ''
      } else {
        this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
        this.form.SchoolId = item.Id

        this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址
        //this.getMeetPackageTypeList(this.form.SchoolId)
        if (this.form.PackageId == 10082) {
          // 只有续订资源包调用
          this.GetSchoolDebtAll(this.form.SchoolId, this.form.OrderId)
        }
        if (this.isKaike && this.form.PackageId !== '') {
          // 转会销开课和转园开课
          this.getSchoolOpenInfo(this.form.SchoolId, this.form.PackageId)
        } else if (this.isSchoolKaike && this.form.PackageId !== '') {
          this.getSchoolOpenInfo(this.OldSchoolId, this.form.PackageId)
        }



      }
    },
    //获取选择弹窗收货地址
    getAddress(item) {
      //console.log(item)
      this.form.ConsigneeProvId = item.ConsigneeProvince
      this.form.ConsigneeCityId = item.ConsigneeCity
      this.form.ConsigneeAreaId = item.ConsigneeArea
      this.form.ConsigneeAddress = item.ConsigneeAdress
      this.form.Consignee = item.Consignee
      this.form.ConsigneeTel = item.ConsigneeTel

      this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
      this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel
      //this.form.SchoolConsigneeId = 0 //代表新增
    },
    // 选择代理商
    chooseAgent() {
      if (this.showData.title == '添加续班订单') {
        this.$refs.chooseDialog.show({
          title: '选择代理商',
          ProjectType: 3
        });
      } else if (this.form.PackageId == 10082) {
        // 续订资源包
        this.$refs.chooseDialog.show({
          title: '选择代理商',
          PackageId: this.form.PackageId
        });
      } else {
        this.$refs.chooseDialog.show({
          title: '选择代理商',
          isKaike: this.isKaike //新增开课true
        });
      }

    },
    //选择园所
    chooseSchool() {
      if (this.form.AgentId == 0) {
        this.$notify({
          title: '警告',
          message: '请先选择代理商',
          type: 'warning'
        });
      } else {
        this.$refs.chooseDialog.show({
          title: '选择园所',
          AgentId: this.form.AgentId,
          isSchoolKaike: this.isSchoolKaike //转园开课

        });

      }

    },
    // 选择精装和简装资源包类型
    // changePackageType(val) {
    //     if (val == 1) {
    //         // 简装单价
    //         this.UnitPrice = 16.82
    //     } else if (val == 2) {
    //         //精装单价
    //         this.UnitPrice = 48
    //     }
    // },
    //修改园所收货地址
    changeAddress() {
      this.$nextTick(() => {
        this.$refs.AddressDialog.show({
          SchoolId: this.form.SchoolId,
          address: this.form,
          Id: this.form.SchoolConsigneeId
        });
      })

    },
    getShowData() {
      return cloneDeep({
        SchoolId: 0,
        title: '',
        isReadOnly: false,
        isShowBtn: false, //true显示选择代理商和园所按钮 只有续订资源包显示
        ClassNum: 0, //总开班数，
        OpenClassNum: 0, //已开课数
        lessClassNum: Infinity, //剩余可开课数
        schoolTitle: "园所",
        PackageId: "",
        isContinueClass: false, //续订资源包true
        isHxOrderList: false, //会销相关页面 true
        isContinueAdd:true
      });
    },
    //初始化数据
    initData() {
      this.form = this.getSubmitFormData()
      this.showData = this.getShowData()
      this.debtPackage = this.getDebtInfoData()
      this.packagesD = this.getPackages();
      this.packageZ = this.getPackageZ(); //智趣坞资源包
      this.GoodsListNum = [{
        "ProId": "",
        "ProNum": 30
      }];
      this.school = ""
      this.agent = ""
      this.ConsigneeList = ''
      this.ConsigneeListName = ''
      this.PackageName = ''
      this.payList = [{}]
      this.loading = false
    },
    show(options) {
      this.initData();
      this.AddDialogVisible = true
      this.showData.title = options.title
      this.isKaike = false
      this.isSchoolKaike = false
      // 设置数据
      if (options.message) {
        //console.log(options.message)
        this.form.AgentId = options.message.AgentId
        this.agent = options.message.AgentName + ' , ' + options.message.C_Name + '  ' + options.message.PhoneNo
        this.school = options.message.SchoolName
        this.form.SchoolId = options.message.SchoolId
        this.showData.PackageId = options.message.PackageId
        this.OldSchoolId = options.message.SchoolId //存储原园所  转园

      }
      // 获取收货地址（园所地址）
      if (this.form.SchoolId !== 0 && this.showData.title !== '转园开课') {
        // 除了转园会销
        this.getSchoolConsigneeList(this.form.SchoolId)
        //this.getMeetPackageTypeList(this.form.SchoolId)

      }
      // 会销相关订单
      if (this.showData.title == '修改订单' || this.showData.title == '查看订单') {
        this.showData.isHxOrderList = true
        if (this.showData.PackageId == 10082) {
          this.showData.isContinueAdd=false
          this.showData.isContinueClass = true
        } else {
          this.showData.isContinueClass = false
        }
        if (this.showData.PackageId == 10121 || this.showData.PackageId == 10083) {
          this.isKaike = true
        }
        this.showData.isShowBtn = false
        this.showData.isReadOnly = options.isReadOnly
        this.form.OrderId = options.message.OrderId
        this.getList(options.message.OrderId)

      } else if (this.showData.title == '续订资源包') {

        this.showData.isHxOrderList = true
        this.showData.isShowBtn = true
        this.showData.isReadOnly = false
        this.showData.isContinueClass = true
        this.form.PackageId = options.PackageId

        this.packagesOne = false
        // 默认寄送方式为物流223  寄付222
        this.form.SendMode = 223
        this.form.PayMode = 222
      } else if (this.showData.title == '转会销开课') {
        // 转会销开课
        this.isKaike = true
        this.showData.isShowBtn = true
      } else if (this.showData.title == '转园开课') {
        // 转园开课入口
        this.isSchoolKaike = true
        this.showData.isShowBtn = false
        this.school = ''
      }


    },
    submit() {
      this.form.OrderPrice = this.price;
      this.form.OrderPostPrice = this.postage
      //"GoodsList": [],//配套实物商品 
      this.form.GoodsList = []
      // if (this.form.PackageId == 1008) {
      //     //开课配套资源包
      //     this.form.GoodsList = this.GoodsListNum
      // } else {
      //     // D套餐
      //     this.form.GoodsList = this.packagesD

      // }
      //两个套餐资源包ui一致
      if (this.form.PackageId == 10082) {
        // 续订资源a.concat
        this.form.GoodsList = this.packagesD.concat(this.packageZ)
      } else {
        this.form.GoodsList = this.packagesD
      }
      console.log(this.form.GoodsList)
      // 判断是都选择套餐
      for (let i = 0; i < this.form.GoodsList.length; i++) {
        if (this.form.GoodsList[i].ProId == '') {
          this.$notify({
            title: '警告',
            message: '请选择套餐',
            type: 'warning'
          });
          return;
        }
      }
      // 支付方式
      this.form.ListMeetPay = []
      for (let i = 0; i < this.payList.length; i++) {
        // 价格为0时不需要填写支付信息
        if (this.form.OrderPrice > 0 || this.form.OrderPostPrice>0) {
          let data = this.$refs['payInfo' + (i + 1)][0].validate();
          if (!data) {
            return;
          }
          this.form.ListMeetPay.push(data);
        } else {
          this.form.ListMeetPay = []
        }
      }
      // 转园会销
      if (this.isSchoolKaike) {
        if (this.school == '') {
          this.$notify({
            title: '警告',
            message: '请先选择园所',
            type: 'warning'
          });
          return;
        }
      }
      //console.log(this.form)
      let rule = [{
        name: "寄送方式",
        value: this.form.SendMode,
        required: true,
      }, {
        name: "寄送支付方式",
        value: this.form.PayMode,
        required: true,
      }, {
        name: "支付对象",
        value: this.form.PayObject,
        required: true,
      }];

      //续订资源包判断代理商及园所
      if (this.form.PackageId == 10082) {
        this.form.SysId = 2
        rule.push({
          name: "代理商",
          value: this.agent,
          required: true,
        }, {
          name: "园所",
          value: this.school,
          required: true,
        });

        if (this.totalNum === 0&&this.bookTotalNum===0) {
          this.$notify({
            title: '警告',
            message: '资源包总数不得为0',
            type: 'warning'
          });
          return;
        }
      }
      if (this.showData.lessClassNum <= 0) {
        this.$notify({
          title: '警告',
          message: '该园所暂无' + this.PackageName + '套餐可开课班级数',
          type: 'warning'
        });
        return;
      }
      var flag = util.checkForm({
        ele: this,
        rules: rule
      });

      if (!flag) {
        return;
      }
      // if (this.lessClassNum == 0) {
      //     // 剩余开课数为0，不能下单
      //     return;
      // }
     
      if (this.form.OrderId == 0) {
        this.getAddOrderList(); //会销开课
      } else {
        this.getUpdateOrderList() //修改
      }
    }
  },
  computed: {
    // 资源包单价
    UnitPrice() {
      if (this.form.PayObject == 0) {
        // 园所88
        return 68
      } else if (this.form.PayObject == 1) {
        //代理商38
        return 38
      }
      return 0
    },
    // 总资源包套数
    totalNum() {
      let num = 0
      // if (this.form.PackageId == 1008) {
      //     for (let i = 0; i < this.GoodsListNum.length; i++) {
      //         num += this.GoodsListNum[i].ProNum
      //     }
      // } else {
      //     // D套餐1012
      //     for (let i = 0; i < this.packagesD.length; i++) {
      //         num += this.packagesD[i].ProNum
      //     }

      // }
      // D套餐1012
      for (let i = 0; i < this.packagesD.length; i++) {
        num += this.packagesD[i].ProNum
      }
      return num


    },
    bookTotalNum() {
      // 智趣坞资源总数
      let num = 0
      // D套餐1012
      for (let i = 0; i < this.packageZ.length; i++) {
        num += this.packageZ[i].ProNum
      }
      return num


    },
    // 邮费
    postage() {
      // 小于等于30套，按24元收取邮费 
      // 大于30套，按一套0.8收取
      if (this.form.PackageId == 10082) {
        // 续订资源包
        //一：只要有免邮次数，其中一种未提资源包数为0；则邮费为0；
        //二：未提资源包数大于0，有免邮次数
        //三：无免邮次数，则邮费临界值30区分
        let num = 0
        let d = this.totalNum * 1 - this.debtPackage.HiDebtInfo * 1
        if (this.totalNum <= 0) {
          // 未下资源包
          num = 0
        } else if (this.debtPackage.FreePostData > 0 && this.debtPackage.HiDebtInfo == 0) {
          num = 0
        } else if (this.debtPackage.FreePostData > 0 && this.debtPackage.HiDebtInfo > 0) {
          if (d <= 0 && this.debtPackage.FreePostData > 0) {
            //若下单是仍存在免邮费次数，且对应物料种类，下单数量未超过未提资源包数
            num = 0
          } else if (d <= 30) {
            num = 24
          } else {
            num = (d * 0.8).toFixed(1)
          }
        } else if (this.totalNum > 0 && this.debtPackage.FreePostData == 0) {
          if (this.totalNum <= 30) {
            num = 24
          } else {
            num = (this.totalNum * 0.8).toFixed(1)
          }
        }
        let num2 = 0
        let d2 = this.bookTotalNum * 1 - this.debtPackage.BookHiData * 1
        //智趣坞
        if (this.bookTotalNum <= 0) {
          // 未下资源包
          num2 = 0
        } else if (this.debtPackage.FreePostData > 0 && this.debtPackage.BookHiData == 0) {
          num2 = 0
        } else if (this.debtPackage.FreePostData > 0 && this.debtPackage.BookHiData > 0) {
          if (d2 <= 0 && this.debtPackage.FreePostData > 0) {
            //若下单是仍存在免邮费次数，且对应物料种类，下单数量未超过未提资源包数
            num2 = 0
          } else if (d2 > 0) {
            if (this.form.ConsigneeProvId == 131 || this.form.ConsigneeProvId == 132 || this.form.ConsigneeProvId == 133) {
              //江浙沪地区131 132 133
              if (d2 <= 30) {
                num2 = 12
              } else {
                num2 = (d2 * 0.4).toFixed(2)
              }
            } else {
              // 非江浙沪地区
              if (d2 <= 30) {

                num2 = 19
              } else {
                num2 = (d2 * 0.63).toFixed(2)
              }
            }
          }
        } else if (this.bookTotalNum > 0 && this.debtPackage.FreePostData == 0) {
          // 没有免邮次数
          if (this.form.ConsigneeProvId == 131 || this.form.ConsigneeProvId == 132 || this.form.ConsigneeProvId == 133) {
            //江浙沪地区131 132 133
            if (this.bookTotalNum <= 30) {
              num2 = 12
            } else {
              num2 = (this.bookTotalNum * 0.4).toFixed(2)
            }
          } else {
            // 非江浙沪地区
            if (this.bookTotalNum <= 30) {
              num2 = 19
            } else {
              num2 = (this.bookTotalNum * 0.63).toFixed(2)
            }
          }
        }
        return (num * 1 + num2 * 1).toFixed(2)

      } else if (this.form.PackageId !== 10082 && this.form.PackageId !== '' && this.totalNum - this.packagesNum > 0) {
        // 转会销计算邮费

        if (this.totalNum - this.packagesNum <= 30) {
          return 24
        } else {
          return ((this.totalNum - this.packagesNum) * 0.8).toFixed(2)
        }
      } else {
        return 0
      }

    },
    // 订单总价
    totalPrice() {
      return (this.postage * 1 + this.price * 1).toFixed(2)
    },
    //资源包价格
    price() {
      // 最新规则 (转会销开课价格、续订资源包价格、会销开课下单价)
      if (this.form.PackageId == 10082) {
        // 续订资源包10082  资源包园所订购价=UnitPrice*（Hi幼教配置的资源包数-Hi幼教未提资源包数）+58（智趣坞配置的资源包-智趣坞未提资源包数）
        // 资源包代理商订购价=UnitPrice*（Hi幼教配置的资源包数-Hi幼教未提资源包数）+17.8（智趣坞配置的资源包-智趣坞未提资源包数）
        let num = 0
        let d1 = 0;
        let d2 = 0;
        let unitPrice2 = 58;
        if (this.totalNum >= this.debtPackage.HiDebtInfo) {
          d1 = this.totalNum - this.debtPackage.HiDebtInfo
        } else {
          d1 = 0
        }
        if (this.bookTotalNum >= this.debtPackage.BookHiData) {
          d2 = this.bookTotalNum - this.debtPackage.BookHiData
        } else {
          d2 = 0
        }
        if (this.form.PayObject === 0) {
          unitPrice2 = 58

        } else if (this.form.PayObject === 1) {
          unitPrice2 = 17.8

        }
        num = this.UnitPrice * d1 + unitPrice2 * d2
        return num.toFixed(2);

      } else if (this.isKaike) {
        // 转会销开课
        if (this.totalNum <= this.packagesNum) {
          if (this.form.PackageId == 10083) {
            // 2017Q4会销开课14000*班级数+【总物料数-（60*开通班级数）*88】
            return 14000 * this.form.ClassNum

          } else if (this.form.PackageId == 10121) {
            // D套餐开课19800*班级数+【总物料数-（60*开通班级数）*88】
            return 19800 * this.form.ClassNum
          }
        } else {
          if (this.form.PackageId == 10083) {
            // 2017Q4会销开课14000*班级数+【总物料数-（60*开通班级数）*88】
            return 14000 * this.form.ClassNum + (this.totalNum - (60 * this.form.ClassNum)) * this.UnitPrice

          } else if (this.form.PackageId == 10121) {
            // D套餐开课19800*班级数+【总物料数-（60*开通班级数）*88】
            return 19800 * this.form.ClassNum + (this.totalNum - (60 * this.form.ClassNum)) * this.UnitPrice
          }
        }

      } else {
        // 会销开课
        //小于或等于60 价格等于0
        if (this.totalNum <= this.packagesNum) {
          return 0
        } else {
          //套餐价格 =（总资源包套数 - 开通班级数 * 60）* this.UnitPrice
          return (this.totalNum - 60 * this.form.ClassNum) * this.UnitPrice
        }
      }
      return 0;


    },
    // 至少配置资源包总数
    packagesNum() {
      return 60 * this.form.ClassNum
    },

  },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addOrderDialog/vm.js